/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Endpoint } from '@coin/shared/core/util-models-v2';
import { EndpointGroup } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CopyEndpointGroupEndpointGroupsParams {
  endpointGroupId: string;
  name?: string;
}

export interface CreateEndpointGroupEndpointGroupsParams {
  endpointGroup?: EndpointGroup;
}

export interface DeleteEndpointGroupEndpointGroupsParams {
  endpointGroupId: string;
}

export interface DuplicateEndpointsEndpointGroupsParams {
  endpointGroupId: string;
  fromEndpointGroupId?: string;
}

export interface GetEndpointGroupDetailsEndpointGroupsParams {
  endpointGroupId: string;
}

export interface UpdateEndpointGroupEndpointGroupsParams {
  endpointGroup?: EndpointGroup;
}

@Injectable({
  providedIn: 'root'
})
export class UsersEndpointPermissionsService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public copyEndpointGroupEndpointGroups(
    requestParameters?: CopyEndpointGroupEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public copyEndpointGroupEndpointGroups(
    requestParameters?: CopyEndpointGroupEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public copyEndpointGroupEndpointGroups(
    requestParameters?: CopyEndpointGroupEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public copyEndpointGroupEndpointGroups(
    requestParameters?: CopyEndpointGroupEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const endpointGroupId = requestParameters?.endpointGroupId;
    this.checkRequired('copyEndpointGroupEndpointGroups', { endpointGroupId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/endpoint-groups/${this.configuration.encodeParam({ name: 'endpointGroupId', value: endpointGroupId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/copy`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { name: requestParameters?.name }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEndpointGroupEndpointGroups(
    requestParameters?: CreateEndpointGroupEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EndpointGroup>;
  public createEndpointGroupEndpointGroups(
    requestParameters?: CreateEndpointGroupEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EndpointGroup>>;
  public createEndpointGroupEndpointGroups(
    requestParameters?: CreateEndpointGroupEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EndpointGroup>>;
  public createEndpointGroupEndpointGroups(
    requestParameters?: CreateEndpointGroupEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v2/master/endpoint-groups`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.endpointGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEndpointGroupEndpointGroups(
    requestParameters?: DeleteEndpointGroupEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteEndpointGroupEndpointGroups(
    requestParameters?: DeleteEndpointGroupEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteEndpointGroupEndpointGroups(
    requestParameters?: DeleteEndpointGroupEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteEndpointGroupEndpointGroups(
    requestParameters?: DeleteEndpointGroupEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const endpointGroupId = requestParameters?.endpointGroupId;
    this.checkRequired('deleteEndpointGroupEndpointGroups', { endpointGroupId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v2/master/endpoint-groups/${this.configuration.encodeParam({ name: 'endpointGroupId', value: endpointGroupId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateEndpointsEndpointGroups(
    requestParameters?: DuplicateEndpointsEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public duplicateEndpointsEndpointGroups(
    requestParameters?: DuplicateEndpointsEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public duplicateEndpointsEndpointGroups(
    requestParameters?: DuplicateEndpointsEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public duplicateEndpointsEndpointGroups(
    requestParameters?: DuplicateEndpointsEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const endpointGroupId = requestParameters?.endpointGroupId;
    this.checkRequired('duplicateEndpointsEndpointGroups', { endpointGroupId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v2/master/endpoint-groups/${this.configuration.encodeParam({ name: 'endpointGroupId', value: endpointGroupId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate-endpoints`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { fromEndpointGroupId: requestParameters?.fromEndpointGroupId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEndpointGroupDetailsEndpointGroups(
    requestParameters?: GetEndpointGroupDetailsEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EndpointGroup>;
  public getEndpointGroupDetailsEndpointGroups(
    requestParameters?: GetEndpointGroupDetailsEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EndpointGroup>>;
  public getEndpointGroupDetailsEndpointGroups(
    requestParameters?: GetEndpointGroupDetailsEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EndpointGroup>>;
  public getEndpointGroupDetailsEndpointGroups(
    requestParameters?: GetEndpointGroupDetailsEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const endpointGroupId = requestParameters?.endpointGroupId;
    this.checkRequired('getEndpointGroupDetailsEndpointGroups', { endpointGroupId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/endpoint-groups/${this.configuration.encodeParam({ name: 'endpointGroupId', value: endpointGroupId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEndpointGroupsEndpointGroups(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<EndpointGroup>>;
  public getEndpointGroupsEndpointGroups(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<EndpointGroup>>>;
  public getEndpointGroupsEndpointGroups(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<EndpointGroup>>>;
  public getEndpointGroupsEndpointGroups(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/endpoint-groups`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEndpointsEndpoint(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<Endpoint>>;
  public getEndpointsEndpoint(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<Endpoint>>>;
  public getEndpointsEndpoint(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<Endpoint>>>;
  public getEndpointsEndpoint(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/endpoints`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRestrictionScopeEndpointGroups(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getRestrictionScopeEndpointGroups(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getRestrictionScopeEndpointGroups(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getRestrictionScopeEndpointGroups(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v2/master/endpoint-groups/restrictions/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEndpointGroupEndpointGroups(
    requestParameters?: UpdateEndpointGroupEndpointGroupsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EndpointGroup>;
  public updateEndpointGroupEndpointGroups(
    requestParameters?: UpdateEndpointGroupEndpointGroupsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EndpointGroup>>;
  public updateEndpointGroupEndpointGroups(
    requestParameters?: UpdateEndpointGroupEndpointGroupsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EndpointGroup>>;
  public updateEndpointGroupEndpointGroups(
    requestParameters?: UpdateEndpointGroupEndpointGroupsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v2/master/endpoint-groups`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.endpointGroup,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
